module.exports = __webpack_public_path__ + "img/tha.f24bdc38.svg";